// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"d7b57ce6","222":"0bacfbb3","316":"76cb0136","387":"66b2142b","431":"d09db83e","693":"e1a5f266","963":"9671f4b5","975":"3537f1d9"}[chunkId] + ".chunk.js";
};